import { defaultStatus } from '@/_schemas/status-input';
import type { RouteListItem } from '@/types';

import { type RelationshipScoreFormSchema } from './schemas';

import { settingsBcLink } from '../../model';

export const defaultValues: Readonly<RelationshipScoreFormSchema> = {
  status: defaultStatus,
  id: -1,
  label: '',
  icon: null,
  number: '',
} as const;

export const breadcrumbsLinks: RouteListItem[] = [
  settingsBcLink,
  { path: '/settings/relationship-scores', name: 'Relationship Scores' },
];
